import React, { ReactNode } from 'react';
import { View, StyleSheet, StyleProp, ViewStyle } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';

import { GRADIENT_CARD, CARD } from '../constants/colors';

type CardProps = {
  style?: StyleProp<ViewStyle>;
  children: ReactNode;
  withGradient?: boolean;
};

type Props = {
  style?: StyleProp<ViewStyle>;
  children: ReactNode;
};

export default function Card(props: CardProps) {
  let { style, children, withGradient = false } = props;

  return withGradient ? (
    <LinearGradient
      colors={GRADIENT_CARD}
      style={[styles.shadowStyle, styles.linearGradient, style]}
    >
      {children}
    </LinearGradient>
  ) : (
    <View style={[styles.shadowStyle, styles.cardContainer, style]}>
      {children}
    </View>
  );
}

function Header({ children, style }: Props) {
  return (
    <View>
      <View style={[styles.header, style]}>{children}</View>
      <View style={styles.divider} />
    </View>
  );
}

function Content({ children, style }: Props) {
  return <View style={[styles.content, style]}>{children}</View>;
}

Card.Header = Header;
Card.Content = Content;

const styles = StyleSheet.create({
  shadowStyle: {
    borderRadius: 12,
    shadowColor: CARD.shadow.GRADIENT,
    shadowOpacity: 0.2,
    shadowRadius: 12,
    shadowOffset: {
      height: 4,
      width: 0,
    },
  },
  cardContainer: {
    backgroundColor: CARD.background,
    padding: 24,
  },
  linearGradient: {
    flex: 1,
    width: '100%',
    padding: 24,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'center',
    paddingBottom: 16,
  },
  divider: {
    height: 0.5,
    opacity: 0.7,
    backgroundColor: CARD.divider,
    alignSelf: 'stretch',
  },
  content: { paddingTop: 16 },
});
